var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.656 22h-10.625c-1.2925 0-2.3438-1.0513-2.3438-2.3438v-10.625c0-1.2925 1.0513-2.3438 2.3438-2.3438h10.625c1.2925 0 2.3438 1.0513 2.3438 2.3438v10.625c0 1.2925-1.0513 2.3438-2.3438 2.3438zm-10.625-13.75c-0.4308 0-0.78126 0.35046-0.78126 0.78126v10.625c0 0.43078 0.35046 0.78126 0.78126 0.78126h10.625c0.43078 0 0.78126-0.35048 0.78126-0.78126v-10.625c0-0.4308-0.35048-0.78126-0.78126-0.78126zm-3.9063 7.5h-0.78124c-0.4308 0-0.78126-0.35046-0.78126-0.78126v-10.625c0-0.4308 0.35046-0.78126 0.78126-0.78126h10.625c0.4308 0 0.78126 0.35046 0.78126 0.78126v0.74219h1.5625v-0.74219c0-1.2925-1.0512-2.3438-2.3438-2.3438h-10.625c-1.2925 0-2.3438 1.0513-2.3438 2.3438v10.625c0 1.2925 1.0513 2.3438 2.3438 2.3438h0.78124z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.ea58009e.svg";
export { ForwardRef as ReactComponent };